import React from "react";
import {TableHeader} from "../table/table-header";

export const ScrollableTableHeaderCellTitle = ({
                                                 className,
                                                 header,
                                                 useShortName,
                                                 ...rest
                                               }) => {

  return (
    <TableHeader className={className} key={header.key}
                 id={header.isMajor ? 'scroll-table-major-header' : 'scroll-table-header'} {...rest}>
      {
        useShortName ? header.shortName : header.name
      }
    </TableHeader>
  )
};

